import { NgModule } from '@angular/core';
import {MobxAutorunDirective} from './directives/mobx-autorun.directive';
import {MobxAutorunSyncDirective} from './directives/mobx-autorun-sync.directive';
import {MobxReactionDirective} from './directives/mobx-reaction.directive';
import {action as mobxAction} from 'mobx';
import {computed as mobxComputed} from 'mobx';
import {observable as mobxObservable} from 'mobx';

export {
  MobxAutorunDirective,
  MobxAutorunSyncDirective,
  MobxReactionDirective
}

const DIRECTIVES = [MobxAutorunDirective, MobxAutorunSyncDirective, MobxReactionDirective];

export class MobxAngularModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    ...DIRECTIVES
  ],
  exports: [
    ...DIRECTIVES
  ],
  imports: [],
  providers: []
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

export function action(...args) {
  return (mobxAction as any)(...args);
}

export function computed(...args) {
  return (mobxComputed as any)(...args);
}

export function observable(...args) {
  return (mobxObservable as any)(...args);
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
